




















// doc: https://github.com/kaorun343/vue-property-decorator
import { Component, Prop, Watch } from 'vue-property-decorator'
import ViewBase from '@/utils/ViewBase'
import { findPass } from '@/api/login'

@Component
export default class Upload extends ViewBase {
  @Prop({ type: Boolean, default: false }) value!: boolean

  form: any = null
  manageuserId: any = null
  loading: boolean = false

  created() {
    this.form = this.$form.createForm(this)
  }

  handleCancel() {
    this.form.resetFields()
    this.$emit('input', false)
  }

  async handleOk() {
    this.loading = true
    const flag = await this.form.validateFields()
    try {
      if (flag) {
        const query = {
          ...flag,
        }
        await findPass(query)
        this.$message.success('邮件发送成功,请注意查收')
        this.$emit('input', false)
        this.form.resetFields()
        this.loading = false
      }
    } catch (ex) {
      this.handleError(ex)
      this.loading = false
    }
  }
}
